export default __webpack_public_path__ + "static/media/YouTubeIcon.79dc8b58.svg";